import React from 'react';

export default function CheckBoxIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M15.5 8L17 9.5 10.5 16 7 12.5 8.5 11l2 2z" fill="currentColor" />
    </svg>
    // <svg width="53" height="50" viewBox="0 0 53 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <rect x="14" y="9" width="24" height="24" rx="12" fill="#E94E32"/>
    //   <g filter="url(#filter0_d_1278_2209)">
    //     <path fillRule="evenodd" clipRule="evenodd" d="M30.5 16.2L32.3 18L24.5 25.8L20.3 21.6L22.1 19.8L24.5 22.2L30.5 16.2Z" fill="white"/>
    //   </g>
    //   <defs>
    //     <filter id="filter0_d_1278_2209" x="0.300049" y="0.199951" width="52" height="49.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    //       <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    //       <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    //       <feOffset dy="4"/>
    //       <feGaussianBlur stdDeviation="10"/>
    //       <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
    //       <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1278_2209"/>
    //       <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1278_2209" result="shape"/>
    //     </filter>
    //   </defs>
    // </svg>
  );
}
